import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Compras } from './compras';

import { Inventario } from './inventario';
import { environment } from '../environments/environment';
import { VCompras } from './vcompras';
import { Compradetalle } from './compradetalle';

@Injectable({
  providedIn: 'root'
})
export class ComprasService {

  constructor(private http: HttpClient) { }

  
  setActulizarCompras(compras: Compras[]){
    console.log(compras);
    return this.http.put<Compras>(environment.apiUrl+"/actulizarCompras",compras);
  }


    
  anularCompras(compras: Compras[]){
    console.log(compras);
    return this.http.put<Compras>(environment.apiUrl+"/anularCompras",compras);
  }

  compras(compras: Compras[]){
    console.log(compras);
    return this.http.put<Compras>(environment.apiUrl+"/compras",compras);
  }

  inventarioProducto(idProducto:number){
    
    return this.http.get<Inventario>(environment.apiUrl+"/ultimoInventario?idProducto=" +idProducto);  
  }

  listaCompras(fecha:string,idEmisor:String){
    
    return this.http.get<VCompras[]>(environment.apiUrl+"/listarVCompras?fecha=" +fecha+"&idEmisor="+idEmisor);  
  }


  listaCompra(id:string){
    
    return this.http.get<Compras[]>(environment.apiUrl+"/listarComprasId?id=" +id);  
  }
  listaCompraDet(id:string){
    
    return this.http.get<Compradetalle[]>(environment.apiUrl+"/listarComprasDetId?id=" +id);  
  }



}
